<template>
  <div>
    <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction">
      <template slot="headerContent">
        <b-col class="pl-0 pr-0 medical-guide-management-layout">
          <b-row class="mt-2 mb-3" align-h="between">
            <div class="w-100 custom-header-Content">
              <div class="d-flex justify-content-start align-items-center search-container">
                <b-form-input id="input-1" class="text-left custom-search" v-model="filterSearch" type="text"
                  placeholder="Busque por CRM..."></b-form-input>
                <img src="@/assets/icons/search.svg" class="search-icon" />
              </div>
              <div class="competence-guide">
                <div class="align-self-center search-control-label">
                  Competência:
                </div>
                <div class="align-self-center custom-selected-date date-picker-container">
                  <vue-monthly-picker class="custom-color-data-picker" v-model="selectedDate"
                    place-holder="Selecione o mês/ano" :monthLabels="allMonth" dateFormat="MM/YYYY"
                    :max="maxDate"></vue-monthly-picker>
                  <div class="calendar-icon-bg">
                    <img src="@/assets/icons/calendar-circle.svg" class="calendar-icon" />
                  </div>
                </div>
              </div>
              <div class="w-100 custom-option">
                <div class="align-self-center search-control-label">
                  Opção alterada:
                </div>
                <b-select v-model="filterTypeId" :options="filterTypes" class="custom-option-select text-left" />
              </div>
              <b-button size="lg" variant="primary" class="mb-2 btn-download" @click="onGenerateReport()"
                v-show="!this.loading" title="Baixar relatório">
                <img class="img-custon" src="@/assets/icons/download.svg" />
              </b-button>
            </div>
          </b-row>
        </b-col>
      </template>
      <template slot="table">
        <div class="scrollme">
          <b-table class="table-custom-log spaced-text" :fields="fields" :items="items" v-show="!loading" show-empty
            empty-text="Nenhuma informação para exibir!">
            <template #cell(publishMedicalGuide)="data">
              <div class="custom-row-table d-flex justify-content-center align-items-center">
                <div :id="'button-' + data.item.id" class="w-100 d-flex justify-content-center align-items-center">
                  <div v-if="!data.item.publishMedicalGuide" class="status-wrapper">
                    <img class="img-medical-guide-status" src="@/assets/icons/close-circle-outline-gray.svg" /><span
                      class="ml-1">Não</span>
                  </div>
                  <div v-if="data.item.publishMedicalGuide" class="status-wrapper">
                    <img class="img-medical-guide-status" src="@/assets/icons/check-circle-outline.svg" /><span
                      class="ml-1 text-success-custom">Sim</span>
                  </div>
                </div>
              </div>
            </template>
            <template #cell(createdAt)="data">
              <div :id="'div-' + data.item.id">{{ data.item.createdAt }}</div>
              <b-tooltip placement="bottom" :target="'div-' + data.item.id">
                {{ data.item.timeCreatedAt }}
              </b-tooltip>
            </template>
          </b-table>
        </div>
        <div v-show="loading">
          <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
        </div>
      </template>
      <template slot="footerContent">
        <div class="d-flex bd-highlight mb-3 justify-content-between"
          :class="isMobile() ? 'flex-column-reverse' : 'flex-row'" style="width: 100%;">
          <div class="mx-auto" :class="isMobile() ? '' : 'pagination-log align-self-center'">
            <b-pagination v-model="page" :total-rows="totalSize" :per-page="perPage" aria-controls="my-table"
              size="lg" />
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
  </div>
</template>

<script>
import _ from "lodash";
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import {
  allMonth,
  dateToLocaleDateString,
  dateToTime,
} from "../../../utils/date/date-utils";
import { resolve_path_url } from "../../../utils/image/image-utils";
import { isMobile } from "../../../utils/mobile/mobile";
import { anchorBase64Download } from "../../../utils/anchor-base64-download/anchor-base64-download";
import { notificationLogs, notificationReportLogs } from "../../../services/updated-informations/updated-informations-service";
import RoutesPaths from "../../../router/router-structure/routes-paths";

export default {
  components: {
    TableVisualizationLayout,
  },
  mounted() {
    this.allMonth = allMonth();
    this.getNotificationsLog();
  },
  computed: {
    shouldFetchData() {
      return this.filterSearch.length > 2 || this.filterSearch.length === 0;
    },
  },
  watch: {
    page: {
      handler() {
        this.getNotificationsLog();
      },
    },
    filterTypeId: {
      handler() {
        this.getNotificationsLog();
      },
    },
    filterSearch: {
      handler: _.debounce(function () {
        if (this.shouldFetchData) {
          this.getNotificationsLog();
        }
      }, 500),
      immediate: false,
    },
    selectedDate: {
      handler() {
        this.getNotificationsLog();
      },
    }
  },
  data() {
    return {
      selectedDate: null,
      maxDate: null,
      allMonth: null,
      filterTypes: [
        { value: null, text: "Todos" },
        { value: "ADDRESS", text: "Endereço" },
        { value: "SPECIALTY", text: "Especialidade" },
        { value: "FIELD_ACTIVITY", text: "Área de atuação" },
        { value: "REQUESTED_CHANGES", text: "Solicitou atualizações" },
        { value: "CONFIRMED_INFORMATION", text: "Confirmou as informações" },
        { value: "CLOSED_SCREEN", text: "Fechou a tela" },
      ],
      filterTypeId: null,
      filterSearch: "",
      page: 1,
      perPage: 10,
      totalSize: 10,
      leftAction: {
        text: "Relatório de atualização do guia médico",
        onClick: this.leftActionClickHandler,
      },
      leftInfo: "",
      fields: [
        { key: "crm", label: "CRM", thStyle: { width: "5%" } },
        { key: "name", label: "Nome", thStyle: { width: "25%" } },
        { key: "descriptionType", label: "Ação / Opção alterada", thStyle: { width: "20%" } },
        { key: "description", label: "Dado alterado", thStyle: { width: "20%" } },
        { key: "publishMedicalGuide", label: "Divulga Guia médico", class: "text-center", thStyle: { width: "15%" } },
        { key: "createdAt", label: "Data e hora", class: "text-center", thStyle: { width: "15%" } },
      ],
      items: [],
      loading: true,
      resolve_path_url,
    };
  },
  methods: {
    isMobile: isMobile,
    async onGenerateReport() {
      const reportResponse = await notificationReportLogs(
        1000000,
        this.page - 1,
        this.filterSearch,
        this.selectedDate,
        this.filterTypeId,
      );
      anchorBase64Download(
        null,
        "application/xls",
        "Relatório de atualização do guia médico" + reportResponse.extension,
        reportResponse.fileBase64
      );
    },
    async getNotificationsLog() {
      try {
        this.loading = true;
        const notificationsLogResponse = await notificationLogs(
          this.perPage,
          this.page - 1,
          this.filterSearch,
          this.selectedDate,
          this.filterTypeId,
        );
        this.items = notificationsLogResponse.items;
        this.totalSize = notificationsLogResponse.totalItems;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("getNotificationsLog", error);
      }
    },
    leftActionClickHandler() {
      this.$router.push(RoutesPaths.contentReportManagement.rootName());
    },
    dateToTime: dateToTime,
    dateToLocaleDate: dateToLocaleDateString,
  },
};
</script>

<style lang="scss">
.vue-monthly-picker .month-picker-wrapper {
  width: 100% !important;
  min-width: auto !important;
}

.medical-guide-management-layout {


  div.table-custom-log td {
    color: var(--grey-1);
    padding-left: 32px;
  }

  div.table-custom-log th {
    padding-left: 32px;
  }

  .vue-monthly-picker {
    width: 100%;
    height: 34px;
  }

  .competence-guide .date-picker-container .custom-color-data-picker .month-picker-wrapper {
    width: 100%;
    min-width: 149px;
    position: relative;
    height: 34px;
  }

  .vue-monthly-picker .month-year-label {
    outline: none;
    height: 34px;
  }

  .date-picker-container .custom-color-data-picker .month-year-display {
    width: 100%;
    height: 34px;
    box-sizing: border-box;
    border: none;
    border-radius: 4px 0 0 4px;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
  }

  .date-picker-container .custom-color-data-picker .month-year-display.input {
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    height: 34px !important;
  }

  .date-picker-container .custom-color-data-picker .month-year-display .display-text {
    flex: 1;
    min-width: 0;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    color: var(--grey-9);
    margin: 0;
    padding: 0 28px 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .date-picker-container .custom-color-data-picker .month-year-display.placeholder {
    color: var(--grey-9);

    .display-text {
      justify-content: flex-start;
    }
  }

  .vue-monthly-picker .month-year-label .vmp-input-append {
    display: flex;
    position: absolute;
    right: 4px;
    top: 0;
    height: 100%;
    width: 20px;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    z-index: 3;
    cursor: pointer;
  }

  .vue-monthly-picker .month-year-label .vmp-input-append .vmp-clear-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: var(--grey-9);
  }

  .vue-monthly-picker .month-year-label .vmp-input-append .vmp-clear-icon::before {
    content: '\00D7';
    font-size: 18px;
    line-height: 1;
  }

  .vue-monthly-picker .month-picker-wrapper .text {
    display: none;
  }

  .vue-monthly-picker .month-picker-wrapper .date-popover {
    top: 38px;
    left: 0;
  }

}
</style>

<style lang="scss" scoped>
.pagination-log ul {
  margin-bottom: 0;
}

.scrollme {
  overflow-x: auto;
}

.btn-download {
  cursor: pointer;
  margin-left: 40px;
  width: 50px;
}

.img-custon-principal {
  width: 100%;
  height: 100%;
}

.competence-guide {
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-content: center;
  align-items: center;
  max-width: 448px;
  width: 100%;
  margin-left: 10px;
}

.custom-header-Content {
  max-width: 100%;
  display: grid;
  column-gap: 24px;
  margin: 32px 0;
}

@media (min-width: 850px) {
  .custom-header-Content {
    grid-template-columns: 25% 30% 30% auto;
  }
}

.custom-search {
  max-width: 100%;
  height: 36px;
  font-size: 14px;

  &::placeholder {
    color: var(--grey-9);
    font-size: 14px;
  }
}

.search-container {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-items: center;
  width: 100%;
}

.search-icon {
  position: absolute;
  right: 12.8px;
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.custom-option {
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-content: center;
  align-items: center;
  max-width: 544px;
  margin-left: 30px;
}

.date-picker-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  max-height: 36px;
  box-sizing: border-box;
  border: 1px solid var(--grey-19);
  border-radius: 5px;
  background-color: var(--background-1);
}

.calendar-icon-bg {
  flex: 0 0 40px;
  width: 40px;
  height: 34px;
  background-color: var(--backgrount-2);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  border-radius: 0 4px 4px 0;
  border-left: 1px solid var(--grey-19);
  box-sizing: border-box;
  margin: 0;
}

.date-picker-container:hover .calendar-icon-bg {
  background-color: var(--grey-20);
}

.calendar-icon {
  width: 24px;
  height: 24px;
}

.custom-option-select {
  max-width: 336px;
  width: 100%;
  height: 36px;
  border-radius: 5px;
  padding-left: 8px;
  color: var(--grey-9);
  font-size: 16px;
  background-image: url('~@/assets/icons/down_arrow.svg') !important;
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px 16px;
}

.custom-selected-date {
  max-width: 368px;
  width: 100%;
}

.custom-color-data-picker {
  flex: 1 1 auto;
  min-width: 0;
  height: 34px;
  margin-bottom: 0;
}

.form-control {
  border-radius: 5px;
}

.search-control-label {
  font-size: 16px;
}

.img-medical-guide-status {
  width: 16px;
  height: 16px;
}

.text-success-custom {
  color: var(--green-4);
}

.status-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>